import { Trans, useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

export function ResultsPage() {
  const { t } = useTranslation();
  const { id } = useParams<{ id: string }>();
  return (
    <div>
      <h1 className="text-2xl font-semibold">{t("page.results.title")}</h1>
      <p className="text-muted-foreground mt-2">
        {/*
          Use <Trans> so the {{id}} interpolation inside the locale string
          can be wrapped in <code> for monospace styling. Plain t() would
          either escape the markup or lose it.
        */}
        <Trans
          i18nKey="page.results.placeholder"
          values={{ id }}
          components={{ code: <code className="font-mono text-foreground" /> }}
        />
      </p>
      {/* TODO(6a.10): implement results display (key metrics, schedule, JE) */}
    </div>
  );
}
